export const TYPE_LABELS = {
  indoor: "Indoor",
  outdoor: "Outdoor",
};

export const TYPE_VALUES = {
  indoor: "indoor",
  outdoor: "outdoor",
};
